import React from 'react';
import { Link } from 'react-router-dom';

const VARIANTS = {
  primary:
    'bg-invert-orange text-white hover:bg-invert-orange-deep shadow-lg shadow-invert-orange/20',
  secondary:
    'bg-white/10 text-white border border-white/20 hover:bg-white/20 backdrop-blur-sm',
  secondaryDark:
    'bg-invert-navy text-white hover:bg-invert-navy-light',
  outline:
    'bg-transparent text-invert-navy border border-invert-navy/20 hover:border-invert-navy/40 hover:bg-invert-navy/5',
  ghost: 'bg-transparent text-invert-text-muted hover:text-invert-navy',
  white: 'bg-white text-invert-navy hover:bg-slate-50 shadow-md',
};

const SIZES = {
  sm: 'px-4 py-2 text-sm rounded-lg',
  md: 'px-6 py-3 text-sm font-medium rounded-xl',
  lg: 'px-8 py-4 text-base font-semibold rounded-xl',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  to,
  href,
  className = '',
  children,
  ...props
}) {
  const classes = `inline-flex items-center justify-center gap-2 transition-all duration-200 cursor-pointer no-underline ${VARIANTS[variant]} ${SIZES[size]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...props}>
      {children}
    </button>
  );
}
